<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="OrderList" 
          :extra-items="readonly ? [
            {
              text: order?.order_number ?? ''
            }
          ] : isEdit ? [
            {
              text: order?.order_number ?? '',
              to: 'OrderDetail',
              params: $route.params.order_id
            },
            '編輯訂單'
          ] : [
            '新增訂單'
          ]"
        />
      </div>
    </div>

    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div v-if="isCreate" class="row mb-3 align-items-center">
          <div class="col-12">
            <h4 class="font-weight-bold">{{ isSimplified ? '新增訂單-精簡' : '新增訂單-標準' }}</h4>
          </div>
          <div class="col-12 col-md-4 mt-2">
            <b-form-select
              v-model="order.merchant_id"
              :options="merchants"
              @change="getOptions(); $router.replace({ query: { ...$route.query, merchant_id: order.merchant_id } })"
            ></b-form-select>
          </div>
        </div>
        <div class="row mb-3 align-items-center">
          <div class="col-12 col-xl-2">
            <h4 class="font-weight-bold">訂單內容</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-4 mb-2">分店名稱(ID)：{{ order.branch ? order.branch.name + '(' + order.branch.id + ')' : '' }}</div>
        </div>
        <div class="row">
          <div class="col-4">
            <b-form-group :disabled=readonly>
              <div v-if="!readonly" class="d-flex align-items-center" style="margin-bottom: 12px;">
                <span class="mr-2 font-weight-bold">新增方式：</span>
                <b-form-radio-group v-model="memberMode" :options="[
                  { value: 'select', text: '選擇現有會員' },
                  { value: 'manual', text: '自行輸入' }
                ]" />
              </div>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="會員姓名"
                :disabled="readonly"
              >
                <template v-if="!readonly && memberMode === 'select'">
                  <div class="d-flex align-items-center">
                    <b-form-input
                      :value="selectedCustomer ? selectedCustomer.name : (order.customer ? order.customer.name : '')"
                      disabled
                      class="mr-2"
                    ></b-form-input>
                    <b-button
                      variant="outline-primary"
                      :disabled="!order.merchant_id"
                      @click="openSelectCustomerModal"
                    >選擇會員</b-button>
                  </div>
                </template>
                <b-form-input
                  v-else-if="!readonly && memberMode === 'manual'"
                  v-model="order.customer_name"
                ></b-form-input>
                <b-form-input
                  v-else
                  :value="order.customer ? order.customer.name : ''"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="識別編號"
                :disabled="readonly || (!readonly && memberMode === 'select')"
              >
                <b-form-input
                  v-if="!readonly && memberMode === 'select'"
                  :value="selectedCustomer ? selectedCustomer.number_code : (order.customer ? order.customer.number_code : '')"
                  disabled
                ></b-form-input>
                <b-form-input
                  v-else-if="!readonly && memberMode === 'manual'"
                  :value="order.customer ? order.customer.number_code : ''"
                  disabled
                ></b-form-input>
                <b-form-input
                  v-else
                  :value="order.customer ? order.customer.number_code : ''"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="手機號碼"
                :disabled="readonly || (!readonly && memberMode === 'select')"
              >
                <b-form-input
                  v-if="!readonly && memberMode === 'select'"
                  :value="selectedCustomer ? selectedCustomer.mobile_phone : (order.customer ? order.customer.mobile_phone : '')"
                  disabled
                ></b-form-input>
                <b-form-input
                  v-else-if="!readonly && memberMode === 'manual'"
                  v-model="order.customer_mobile"
                ></b-form-input>
                <b-form-input
                  v-else
                  :value="order.customer ? order.customer.mobile_phone : ''"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="訂單編號(內部)"
              >
                <b-form-input v-model="order.order_number" :disabled="isSimplified"></b-form-input>
                <b-form-invalid-feedback v-if="isCreate && !isSimplified" :state="!v$.order.order_number.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="外部訂單編號"
              >
                <b-form-input v-model="order.outer_order_number" :disabled="isSimplified"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="外部會員ID"
              >
                <b-form-input
                  v-if="!readonly && memberMode === 'select'"
                  :value="order.customer_outer_code"
                  disabled
                  placeholder="選擇現有會員，不需填寫"
                ></b-form-input>
                <b-form-input
                  v-else-if="!readonly && memberMode === 'manual'"
                  v-model="order.customer_outer_code"
                ></b-form-input>
                <b-form-input
                  v-else
                  :value="order.customer_outer_code"
                ></b-form-input>
              </b-form-group>
              <b-form-checkbox
                v-if="isCreate && memberMode === 'manual'"
                v-model="autoGenerateMember"
                :disabled="memberMode === 'select'"
              >
                <span class="text-danger">自動建立會員編號</span>
              </b-form-checkbox>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="訂單狀態"
              >
                <b-form-select v-model="order.status" :options="orderStatusOptions"></b-form-select>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="付款方式"
              >
                <b-form-input v-model="order.payment_type"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="配送方式"
              >
                <b-form-input v-model="order.delivery_type"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="付款狀態"
              >
                <b-form-input v-model="order.payment_status"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="運送狀態"
              >
                <b-form-select v-model="order.delivery_status" :options="deliveryStatusOptions"></b-form-select>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="消費者備註狀態"
              >
                <b-form-input v-model="order.memo"></b-form-input>
              </b-form-group>
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group :disabled=readonly>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="下單時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.order_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      v-if="order.order_at.time"
                      format="HH:mm"
                      v-model="order.order_at.time"
                      :input-class="['form-control']"
                      :hide-clear-button="true"
                    ></vue-timepicker>
                    <b-form-input v-else></b-form-input>
                  </div>
                </div>
                <b-form-invalid-feedback v-if="isCreate" :state="!v$.order.order_at.date.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="訂單狀態日"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.status_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      v-if="order.status_at.time"
                      format="HH:mm"
                      v-model="order.status_at.time"
                      :input-class="['form-control']"
                      :hide-clear-button="true"
                    ></vue-timepicker>
                    <b-form-input v-else></b-form-input>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="訂單確認日期"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.confirm_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      v-if="order.status_at.time"
                      format="HH:mm"
                      v-model="order.confirm_at.time"
                      :input-class="['form-control']"
                      :hide-clear-button="true"
                    ></vue-timepicker>
                    <b-form-input v-else></b-form-input>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="完成時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.completed_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      v-if="order.completed_at.time"
                      format="HH:mm"
                      v-model="order.completed_at.time"
                      :input-class="['form-control']"
                      :hide-clear-button="true"
                    ></vue-timepicker>
                    <b-form-input v-else></b-form-input>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="建立時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.created_at"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                      :disabled=true
                    ></datepicker>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="更新時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      v-model="order.updated_at"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                      :disabled=true
                    ></datepicker>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="金額小計"
              >
                <b-form-input v-model="order.sub_total"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="訂單折扣"
              >
                <b-form-input v-model="order.order_discount"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="運費"
              >
                <b-form-input v-model="order.delivery_fee"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="金流費"
              >
                <b-form-input v-model="order.payment_fee"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="總價(含稅)"
              >
                <b-form-input v-model="order.total" :disabled="isSimplified"></b-form-input>
                <b-form-invalid-feedback v-if="isCreate && !isSimplified" :state="!v$.order.total.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
            </b-form-group>
          </div>
        </div>
        <div class="row mt-4 align-items-center">
          <div class="col-12 col-xl-2">
            <h4 class="font-weight-bold">訂單明細</h4>
          </div>
        </div>
        <div class="text-right" v-if="!readonly && !(isSimplified && order.items.length >= 1)">
          <b-button
            class="flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2"
            variant="primary"
            @click="addItemHandler"
          ><i class="fa fa-plus" aria-hidden="true"></i
          >新增商品
          </b-button
          >
        </div>
        <b-table
          striped
          hover
          responsive
          :items="order.items"
          :fields="fields"
          :busy="showLoading"
          class="order-detail-table"
        >
          <template #cell(outer_order_item_number)="data">
            <div v-if="readonly">
              <span :id="`popover-order-item-${data.index}`" class="text-truncate-cell">
                {{ data.item.outer_order_item_number }}
              </span>
              <b-popover
                v-if="data.item.outer_order_item_number"
                :target="`popover-order-item-${data.index}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.outer_order_item_number }}</div>
              </b-popover>
            </div>
            <div v-else>
              <b-form-input v-model="data.item.outer_order_item_number"></b-form-input>
              <b-form-invalid-feedback
                v-if="isCreate && isItemFieldRequired('outer_order_item_number')"
                style="margin-bottom: -16px;"
                :state="!getItemFieldError(data.index, 'outer_order_item_number')"
              >
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
          </template>
          <template #cell(title)="data">
            <div v-if="readonly">
              <span :id="`popover-title-${data.index}`" class="text-truncate-cell">
                {{ data.item.title }}
              </span>
              <b-popover
                v-if="data.item.title"
                :target="`popover-title-${data.index}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.title }}</div>
              </b-popover>
            </div>
            <div v-else>
              <b-form-input v-model="data.item.title"></b-form-input>
            </div>
          </template>
          <template #cell(sku_name)="data">
            <div v-if="readonly">
              <span :id="`popover-sku-name-${data.index}`" class="text-truncate-cell">
                {{ data.item.sku_name }}
              </span>
              <b-popover
                v-if="data.item.sku_name"
                :target="`popover-sku-name-${data.index}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.sku_name }}</div>
              </b-popover>
            </div>
            <div v-else>
              <b-form-input v-model="data.item.sku_name"></b-form-input>
            </div>
          </template>
          <template #cell(sku_code)="data">
            <div v-if="readonly">
              <span :id="`popover-sku-code-${data.index}`" class="text-truncate-cell">
                {{ data.item.sku_code }}
              </span>
              <b-popover
                v-if="data.item.sku_code"
                :target="`popover-sku-code-${data.index}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.sku_code }}</div>
              </b-popover>
            </div>
            <div v-else>
              <b-form-input v-model="data.item.sku_code"></b-form-input>
            </div>
          </template>
          <template #cell(sku_serial_number)="data">
            <div v-if="readonly">
              <span :id="`popover-sku-serial-${data.index}`" class="text-truncate-cell">
                {{ data.item.sku_serial_number }}
              </span>
              <b-popover
                v-if="data.item.sku_serial_number"
                :target="`popover-sku-serial-${data.index}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.sku_serial_number }}</div>
              </b-popover>
            </div>
            <div v-else>
              <b-form-input v-model="data.item.sku_serial_number"></b-form-input>
            </div>
          </template>
          <template #cell(name)="data">
            <div v-if="readonly">
              {{ data.item.sku_name }}
              {{ data.item.sku_code }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="3"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="商品名稱"
              >
                <b-form-input v-model="data.item.sku_name"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-sm="3"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="商品編號"
              >
                <b-form-input v-model="data.item.sku_code"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(price)="data">
            <div v-if="readonly">
              {{ data.item.price }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.price"></b-form-input>
                <b-form-invalid-feedback
                  v-if="isCreate && isItemFieldRequired('price')"
                  style="margin-bottom: -16px;"
                  :state="!getItemFieldError(data.index, 'price')"
                >
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </template>
          <template #cell(quantity)="data">
            <div v-if="readonly">
              {{ data.item.quantity }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.quantity"></b-form-input>
                <b-form-invalid-feedback
                  v-if="isCreate && isItemFieldRequired('quantity')"
                  style="margin-bottom: -16px;"
                  :state="!getItemFieldError(data.index, 'quantity')"
                >
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </template>
          <template #cell(total_price)="data">
            <div v-if="readonly">
              {{ data.item.total_price }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.total_price"></b-form-input>
                <b-form-invalid-feedback
                  v-if="isCreate && isItemFieldRequired('total_price')"
                  style="margin-bottom: -16px;"
                  :state="!getItemFieldError(data.index, 'total_price')"
                >
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </template>
          <template #cell(total_discount)="data">
            <div v-if="readonly">
              {{ data.item.total_discount }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6">
                <b-form-input type="number" v-model="data.item.total_discount"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(total_payment)="data">
            <div v-if="readonly">
              {{ data.item.total_payment }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6">
                <b-form-input type="number" v-model="data.item.total_payment"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(status)="data">
            <div v-if="readonly">
              {{ data.item.status }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="訂單狀態">
                <b-form-select v-model="data.item.status" :options="orderStatusOptions"></b-form-select>
              </b-form-group>
            </div>
            <div>
              {{ format(new Date(data.item.status_at), "yyyy-MM-dd HH:mm") }}
            </div>
            <div>
              {{ format(new Date(data.item.confirm_at), "yyyy-MM-dd HH:mm") }}
            </div>
          </template>
          <template #cell(delivery)="data">
            <div v-if="readonly">
              {{ data.item.delivery_status }}
              {{ data.item.delivery_type }}
              {{ data.item.delivery_shipping_code }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="配送狀態">
                <b-form-select v-model="data.item.delivery_status" :options="deliveryStatusOptions"></b-form-select>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="配送方式">
                <b-form-input v-model="data.item.delivery_type"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="貨運單配送編號">
                <b-form-input v-model="data.item.delivery_shipping_code"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(return)="data">
            <div v-if="readonly" style="color: red">
              {{ data.item.return_shipping_code }}
              {{ data.item.return_shipping_id }}
              {{ data.item.return_status }}
            </div>
            <div v-else style="color: red">
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="退貨運單配送編號">
                <b-form-input v-model="data.item.return_shipping_code"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="退貨運單配送id">
                <b-form-input v-model="data.item.return_shipping_id"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="6"
                content-cols-sm="6"
                label="退貨狀態">
                <b-form-input v-model="data.item.return_status"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(processed_memo)="data">
            <div class="d-flex flex-column align-items-center">
              <span
                v-if="data.item.processed_memo"
                v-b-modal.modal-memo-view
                class="mdi mdi-coin"
                style="cursor: pointer; font-size: 1.5rem;"
                :id="`popover-points-${data.item.id}`"
                @click="modalTitle = '入點說明', modalContent = data.item.processed_memo"
              ></span>
              <b-popover
                v-if="data.item.processed_memo"
                :target="`popover-points-${data.item.id}`"
                triggers="hover focus"
              >
                <div class="text-left">點擊，觀看『入點說明』</div>
              </b-popover>
            </div>
          </template>
          <template #cell(arrange)="data" v-if="!readonly">
            <b-button
              v-if="!isSimplified"
              class="delete-button"
              variant="danger"
              @click="removeItemHandler(data.index)"
            >刪除商品</b-button>
          </template>
        </b-table>
        <b-form-invalid-feedback
          v-if="isCreate"
          :state="!(v$.order.items.$dirty && v$.order.items.required.$invalid)"
        >
          請至少新增一筆訂單明細
        </b-form-invalid-feedback>
        <div class="d-flex justify-content-center" v-if="!readonly" style="margin-top: 80px">
          <b-button class="mr-4" variant="outline-danger" @click="handleCancel">
            <template>返回</template>
          </b-button>
          <b-button variant="success" @click="handleSubmit">
            <template v-if="isEdit">確認編輯</template>
            <template v-if="isCreate">確認新增</template>
          </b-button>
        </div>
      </b-overlay>
    </b-card>

    <!-- Memo View Modal -->
    <b-modal id="modal-memo-view" :title="modalTitle">
      <div class="p-3" style="white-space: pre-wrap; max-height: 400px; overflow-y: auto;">{{ modalContent }}</div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>

    <StaffAddCustomer
      ref="selectCustomerModal"
      :show-btn="false"
      :can-select="false"                                                                                                                                   
      :source-type="selectedMerchantSourceType"     
      title="選擇會員"
      @bind="handleCustomerSelected"
    />
  </div>
</template>

<script>
import {format, set, formatISO} from "date-fns";
import orderApi from "../../../apis/order";
import { mapGetters, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import {zh} from "vuejs-datepicker/dist/locale";
import getHours from "date-fns/getHours/index";
import getMinutes from "date-fns/getMinutes/index";
import VueTimepicker from "vue2-timepicker";
import merchantApi from "../../../apis/merchant";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";
import StaffAddCustomer from "@/pages/Dashboard/Staff/StaffAddCustomer.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, requiredIf } from "@vuelidate/validators";

export default {
  components: {Datepicker, VueTimepicker, BreadCrumb, StaffAddCustomer},
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    const requiredIfCreate = requiredIf(() => this.isCreate);
    const requiredIfStandard = requiredIf(() => this.isCreate && !this.isSimplified);
    return {
      order: {
        order_number: { required: requiredIfStandard },
        order_at: {
          date: { required: requiredIfCreate },
        },
        total: { required: requiredIfStandard },
        items: {
          required: requiredIfCreate,
          $each: helpers.forEach({
            outer_order_item_number: { required: requiredIfCreate },
            total_price: { required: requiredIfCreate },
            quantity: { required: requiredIfStandard },
            price: { required: requiredIfStandard },
          }),
        },
      },
    };
  },
  data() {
    return {
      zh,
      showLoading: false,
      order: {
        order_at: {
          date: new Date(),
          time: {
            HH: "00",
            mm: "00",
          },
        },
        status_at: {
          date: new Date(),
          time: {
            HH: "23",
            mm: "59",
          },
        },
        confirm_at: {
          date: new Date(),
          time: {
            HH: "23",
            mm: "59",
          },
        },
        completed_at: {
          date: new Date(),
          time: {
            HH: "23",
            mm: "59",
          },
        },
        items: [],
      },
      baseFields: [
        {key: "outer_order_item_number", label: "訂單明細編號", thStyle: { width: '150px', minWidth: '150px' }, tdClass: 'text-truncate-hover'},
        {key: "title", label: "商品標題", thStyle: { width: '150px', minWidth: '150px' }, tdClass: 'text-truncate-hover'},
        {key: "sku_name", label: "規格名稱", thStyle: { width: '120px', minWidth: '120px' }, tdClass: 'text-truncate-hover'},
        {key: "sku_code", label: "規格代碼", thStyle: { width: '120px', minWidth: '120px' }, tdClass: 'text-truncate-hover'},
        {key: "sku_serial_number", label: "規格序號", thStyle: { width: '150px', minWidth: '150px' }, tdClass: 'text-truncate-hover'},
        {key: "price", label: "售價", thStyle: { minWidth: '80px', width: '80px' }, tdClass: 'text-center compact-cell'},
        {key: "quantity", label: "數量", thStyle: { minWidth: '60px', width: '60px' }, tdClass: 'text-center compact-cell'},
        {key: "total_price", label: "小計", thStyle: { minWidth: '80px', width: '80px' }, tdClass: 'text-center compact-cell'},
        {key: "processed_memo", label: "其他說明", thStyle: { width: '100px', minWidth : '100px' }},
      ],
      orderStatusOptions: [
        {value: null, text: '請選擇狀態'},
        {value: 'Confirmed', text: '已成立'},
        {value: 'Finish', text: '已完成'},
        {value: 'Cancel', text: '已取消'},
        {value: 'WaitingToShipping', text: '出貨準備中'},
        {value: 'WaitingToCreditCheck', text: '付款確認中'},
        {value: 'ConfirmedToShipping', text: '已確認待出貨'},
        {value: 'WaitingToPay', text: '待付款'},
        {value: 'WaitingToModifyStore', text: '門市閉店，待消費者重選'},
      ],
      deliveryStatusOptions: [
        {value: "Finish", text: "已取貨"},
        {value: "Cancel", text: "已取消"},
        {value: "AllocatedCode",  text: "已配號"},
        {value: "VerifySuccess",  text: "超商驗收成功"},
        {value: "VerifyFailLost", text: "超商驗收失敗"},
        {value: "VerifyFailAbnormalPackage",  text: "超商驗收失敗"},
        {value: "VerifyFailRenovation", text: "超商驗收失敗"},
        {value: "VerifyFailErrorCode",  text: "超商驗收失敗"},
        {value: "VerifyFailInvalIdCode",  text: "超商驗收失敗"},
        {value: "ShippingFail", text: "超商逾期未取"},
        {value: "ShippingProcessing", text: "出貨處理中"},
        {value: "ShippingArrived",  text: "貨到門市"},
        {value: "CashOnDeliveryTransferring", text: "宅配轉運中"},
        {value: "CashOnDeliveryNotAtHome",  text: "宅配不在家"},
        {value: "CashOnDeliveryDistributing", text: "宅配已配送"},
        {value: "CashOnDeliveryFailDamage", text: "宅配異常損壞"},
        {value: "CashOnDeliveryFailLost", text: "宅配異常遺失"},
        {value: "CashOnDeliveryFail", text: "宅配出貨失敗"},
        {value: "CashOnDeliveryAddressError", text: "宅配地址錯誤"},
        {value: "CashOnDeliveryForwarding", text: "宅配轉寄配送中"}
      ],
      modalTitle: null,
      modalContent: null,
      merchants: [],
      memberMode: 'select',
      autoGenerateMember: false,
      selectedCustomer: null,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapGetters("route", ["routeQuery"]),
    readonly() {
      return this.$route.name === "OrderDetail"
    },
    isEdit() {
      return this.$route.name === "OrderEdit"
    },
    isCreate() {
      return this.$route.name === "OrderCreate"
    },
    isSimplified() {
      return String(this.$route.query.simplified) === '1'
    },
    fields() {
      const fields = [...this.baseFields];
      if (!this.readonly) {
        fields.push({ key: 'arrange', label: '管理' });
      }
      return fields;
    },
    isItemFieldRequired() {
      return (key) => {
        if (!this.isCreate) return false;
        const simplifiedKeys = ['outer_order_item_number', 'total_price'];
        const standardKeys = ['outer_order_item_number', 'quantity', 'total_price', 'price'];
        return (this.isSimplified ? simplifiedKeys : standardKeys).includes(key);
      };
    },
    selectedMerchantSourceType() {
      console.log("merchants", this.merchants)
      const merchant = this.merchants.find((m) => m.value === this.order.merchant_id);
      return merchant?.type ? merchant.type.toLowerCase() : 'line';
    },
  },
  watch: {
    autoGenerateMember(val) {
      if (val && this.memberMode !== 'manual') {
        this.order.customer_outer_code = '';
      }
    },
    memberMode(val) {
      if (val === 'manual') {
        this.selectedCustomer = null;
        this.order.customer_id = '';
        this.order.customer_name = '';
        this.order.customer_mobile = '';
        this.order.customer_outer_code = '';
      }
    },
    'order.items': {
      deep: true,
      handler(items) {
        if (!this.isSimplified || !items || !items.length) return;
        const first = items[0];
        if (first.outer_order_item_number !== this.order.order_number) {
          this.order.order_number = first.outer_order_item_number;
        }
        if (first.outer_order_item_number !== this.order.outer_order_number) {
          this.order.outer_order_number = first.outer_order_item_number;
        }
        if (first.total_price !== this.order.total) {
          this.order.total = first.total_price;
        }
      },
    },
  },
  mounted() {
    if (!this.isCreate) {
      this.fetchOrder()
    }
    if (!this.readonly) {
      this.getOptions()
    }
    if (this.isCreate) {
      this.fetchMerchants()
      if (this.$route.query.merchant_id) {
        this.order.merchant_id = this.$route.query.merchant_id
        this.getOptions()
      }
      // 進入新增頁時自動加一筆明細，省去使用者按「新增商品」
      if (this.order.items.length === 0) {
        this.addItemHandler()
      }
    }
  },
  methods: {
    format,
    getItemFieldError(index, field) {
      if (!this.v$?.order?.items?.$dirty) return false;
      const fieldState = this.v$?.order?.items?.$each?.$response?.$data?.[index]?.[field];
      return fieldState?.$invalid ?? false;
    },
    async fetchMerchants() {
      try {
        const { data } = await merchantApi.list();
        this.merchants = [
          { value: null, text: '請選擇通路' },
          ...data.data.map((merchant) => ({
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
            type: merchant.type,
          })),
        ];
      } catch (error) {
        console.error(error);
      }
    },
    openSelectCustomerModal() {
      this.$refs.selectCustomerModal.selectedMerchantId = this.order.merchant_id;
      this.$refs.selectCustomerModal.showModal();
    },
    handleCustomerSelected(customer) {
      this.selectedCustomer = customer;
      this.order.customer_outer_code = customer.outer_code;
    },
    async getOptions() {
      this.selectedCustomer = null;
      const dataSource = this.getModuleConfig("order","data_source")
      if (dataSource.length > 0) {
        const merchantId = this.order.merchant_id
        const merchant = await merchantApi.getMerchant(this.organization.id, merchantId)
        const source =  dataSource.find((item)=> (item.source_type).toUpperCase() === merchant.data.data.type)
        if (source) {
          this.orderStatusOptions = source.order_status_mapping.map((item) => {
            return {
              value: item.key,
              text: item.title
            }
          })
          this.deliveryStatusOptions = source.delivery_status_mapping.map((item) => {
            return {
              value: item.key,
              text: item.title
            }
          })
        }
      }
    },
    formatToDateObject(datetime) {
      if (!datetime) {
        return {}
      }
      return {
        date: new Date(datetime),
        time: {
          HH: String(getHours(new Date(datetime))).padStart(2, "0"),
          mm: String(getMinutes(new Date(datetime))).padStart(2, "0"),
        },
      }
    },
    async fetchOrder() {
      this.showLoading = true;

      try {
        const {data} = await orderApi.getOrder(this.$route.params.order_id);
        this.order = data.data;

        this.order.order_at = this.formatToDateObject(this.order.order_at)
        this.order.status_at = this.formatToDateObject(this.order.status_at)
        this.order.confirm_at = this.formatToDateObject(this.order.confirm_at)
        this.order.completed_at = this.formatToDateObject(this.order.completed_at)
        this.getOptions()
      } catch (error) {
        console.error(error);
        alert("取得群組資料錯誤");
      }
      this.showLoading = false;
    },
    handleCancel() {
      this.$router.push({ name: "OrderList", query: this.routeQuery });
    },
    formatToDatetimeString(datetime) {
      if (datetime.date) {
        return formatISO(
          set(new Date(datetime.date), {
              hours: Number(datetime.time.HH),
              minutes: Number(datetime.time.mm),
              seconds: 0,
            },
          )
        )
      } else {
        return {}
      }
    },
    async handleSubmit() {
      if (this.isCreate) {
        const valid = await this.v$.$validate();
        if (!valid) return;
      }

      this.showLoading = true;

      // Snapshot original date objects so a failed submit can be retried
      const originalDates = {
        order_at: this.order.order_at,
        status_at: this.order.status_at,
        confirm_at: this.order.confirm_at,
        completed_at: this.order.completed_at,
      };
      this.order.order_at = this.formatToDatetimeString(this.order.order_at)
      this.order.status_at = this.formatToDatetimeString(this.order.status_at)
      this.order.confirm_at = this.formatToDatetimeString(this.order.confirm_at)
      this.order.completed_at = this.formatToDatetimeString(this.order.completed_at)

      if (this.isEdit) {
        if (this.selectedCustomer) {
          this.order.customer_id = this.selectedCustomer.id;
          this.order.customer_outer_code = this.selectedCustomer.outer_code;
        } else if (this.order.customer) {
          this.order.customer_id = this.order.customer.number_code;
          this.order.customer_outer_code = this.order.customer.outer_code;
        }
        await this.goUpdate(originalDates)
      }
      if (this.isCreate) {
        if (this.memberMode === 'select' && this.selectedCustomer) {
          this.order.customer_id = this.selectedCustomer.id;
        }
        if (this.memberMode === 'manual') {
          this.order.auto_generate_member = this.autoGenerateMember;
        }
        // 精簡模式：明細編號既是 outer_order_number 也是 order_number；總價以明細總價帶入
        if (this.isSimplified && this.order.items.length) {
          const itemNumber = this.order.items[0].outer_order_item_number;
          if (!this.order.order_number) this.order.order_number = itemNumber;
          if (!this.order.outer_order_number) this.order.outer_order_number = itemNumber;
          if (!this.order.total) this.order.total = this.order.items[0].total_price;
        }
        // outer_order_number 在 DB 為 NOT NULL，缺值時以 order_number 取代
        if (!this.order.outer_order_number) {
          this.order.outer_order_number = this.order.order_number;
        }
        await this.goCreate(originalDates)
      }

      this.showLoading = false;
    },
    restoreDateObjects(originalDates) {
      this.order.order_at = originalDates.order_at;
      this.order.status_at = originalDates.status_at;
      this.order.confirm_at = originalDates.confirm_at;
      this.order.completed_at = originalDates.completed_at;
    },
    async goUpdate(originalDates) {
      try {
        await orderApi.updateOrder(this.order.id, this.order);
        this.$swal
          .fire({
            icon: "success",
            text: "更新成功",
          })
          .then(() => {
            this.$router.push({ name: "OrderList", query: this.routeQuery });
          });
      } catch (error) {
        console.error(error);
        if (originalDates) this.restoreDateObjects(originalDates);
        const msg = error.response?.data?.message || error.message || '更新失敗';
        this.$swal.fire({ icon: 'error', title: '更新失敗', text: msg });
      }
    },
    async goCreate(originalDates) {
      try {
        await orderApi.createOrder(this.order);
        this.$swal
          .fire({
            icon: "success",
            text: "新增成功",
          })
          .then(() => {
            const params = { name: "OrderList", query: { ...this.routeQuery, merchant_id: this.order.merchant_id } };
            this.$router.push(params);
          });
      } catch (error) {
        console.error(error);
        if (originalDates) this.restoreDateObjects(originalDates);
        const msg = error.response?.data?.message || error.message || '新增失敗';
        this.$swal.fire({ icon: 'error', title: '新增失敗', text: msg });
      }
    },
    addItemHandler() {
      this.order.items.push({
        id: null,
        outer_order_item_number: '',
        sku_name: null,
        sku_code: null,
        price: 0,
        quantity: 0,
        total_price: '',
        total_discount: 0,
        status: null,
        status_at: null,
        confirm_at: null,
        delivery_status: null,
        delivery_type: null,
        delivery_shipping_code: null,
        return_shipping_code: null,
        return_shipping_id: null,
        return_status: null,
      })
    },
    removeItemHandler(index) {
      this.order.items = this.order.items.filter((_, i) => i !== index);
      this.$emit('input', this.order);
    },
  },
};
</script>

<style scoped>
/* 訂單明細表格 - 固定欄寬樣式 */
.order-detail-table {
  table-layout: fixed;
  width: 100%;
}

/* 文字截斷儲存格 - 用於 span 元素 */
.order-detail-table >>> .text-truncate-cell {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 文字過長時以 ... 截斷，使用 tooltip 顯示完整文字 */
.order-detail-table >>> .text-truncate-hover {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 緊湊型儲存格 - 縮小 padding 讓數字完整顯示 */
.order-detail-table >>> .compact-cell {
  padding: 0.5rem 0.25rem !important;
  white-space: nowrap;
}
</style>
